import { connected } from 'process'
import deviceVersionObj from '../deviceVersion.json'

/**
 * Compares two versions. If (version1 < version2) returns 1,
 * (version1 > version2) returns -1, (version1 = version2) return 0.
 * @param {string} version1
 * @param {string} version2
 * @returns {number} <1, -1, 0>
 */
const compareVersion = (version1, version2) => {
    version1 = version1.split('.').map((num) => parseInt(num))
    version2 = version2.split('.').map((num) => parseInt(num))

    if (version1.length < 3 || version2.length < 3) return

    console.log(version1, version2)

    try {
        for (let index = 0; index < 3; index++) {
            if (version1[index] < version2[index]) return 1
            else if (version1[index] > version2[index]) return -1
        }
        // if (version1[2] < version2[2]) return 1
        return 0
    } catch (e) {
        console.log('ERROR', e)
        return 0
    }
}

const getVersionArguments = {
    Ace0: {
        deviceName: 'Playcomputer',
        version: '0.1',
    },
    Ace1: {
        deviceName: 'Playcomputer',
        version: '1.0',
    },
    Roboki: {
        deviceName: 'Roboki',
        version: '1.0',
    },
    Humanoid: {
        deviceName: 'Zing',
        version: '2.2',
    },
    Hexapod: {
        deviceName: 'Crawlee',
        version: '2.0',
    },
    Klaw: {
        deviceName: 'Klaw',
        version: '1.0',
    },
    Atr: {
        deviceName: 'Atr',
        version: '1.0',
    },
    Toki: {
        deviceName: 'Toki',
        version: '1.0',
    },
    Poki: {
        deviceName: 'Poki',
        version: '1.0',
    },
    Moki: {
        deviceName: 'Moki',
        version: '1.0',
    },
}

// Zing ships as separate hardware series (2.0.x, 2.1.x, ...), so for a connected
const getVersionSeries = (allowedDevice, connectedVersion) => {
    const defaultSeries = getVersionArguments[allowedDevice]?.version || '1.0'
    if (allowedDevice !== 'Humanoid') return defaultSeries

    const series = String(connectedVersion || '')
        .split('.')
        .slice(0, 2)
        .join('.')
   
    let zingSeries = deviceVersionObj.zing
    try {
        zingSeries =
            JSON.parse(sessionStorage.getItem('versionData'))?.zing ||
            zingSeries
    } catch (e) {}
    return zingSeries?.[series] ? series : defaultSeries
}

const isVersionAbove = (version, base) => {
    const a = String(version || '')
        .split('.')
        .map((n) => parseInt(n) || 0)
    const b = String(base || '')
        .split('.')
        .map((n) => parseInt(n) || 0)
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const x = a[i] || 0
        const y = b[i] || 0
        if (x !== y) return x > y
    }
    return false
}

const isVersionAtLeast = (version, base) => {
    // version >= base  (inclusive). Equivalent to: base is not greater.
    return !isVersionAbove(base, version)
}

const PEECEE_MIN_FIRMWARE_BY_BRANCH = {
    '1.0': '1.0.12',
    1.1: '1.1.12',
}

const getPeeCeeMinFirmwareForVersion = (version) => {
    const branch = String(version || '')
        .split('.')
        .slice(0, 2)
        .join('.')
    return PEECEE_MIN_FIRMWARE_BY_BRANCH[branch] || null
}

const ZING_MIN_FIRMWARE_BY_BRANCH = {
    '2.0': '2.0.7',
    2.1: '2.1.7',
    2.2: '2.2.7',
}

const getZingMinFirmwareForVersion = (version) => {
    const branch = String(version || '')
        .split('.')
        .slice(0, 2)
        .join('.')
    return ZING_MIN_FIRMWARE_BY_BRANCH[branch] || null
}

// Returns the minimum supported firmware when the connected version is below
// it (the device must be force-updated), otherwise null.
const getRequiredFirmwareMin = (deviceId, version) => {
    let min = null
    if (deviceId === 'Ace' && String(version || '')[0] === '1')
        min = getPeeCeeMinFirmwareForVersion(version)
    else if (deviceId === 'Humanoid') min = getZingMinFirmwareForVersion(version)
    return min && !isVersionAtLeast(version, min) ? min : null
}

const getVersionObjNameKey = (connectedDevice) => {
    if (connectedDevice === 'Ace') return 'Playcomputer'
    if (connectedDevice === 'Hexapod') return 'Crawlee'
    if (connectedDevice === 'Humanoid') return 'Zing'
    if (connectedDevice === 'Atr') return 'Atr_h2'

    return connectedDevice
}

/**
 * Resolves Zing's ultrasonic variant from sessionStorage:
 * - 'hardwareVariant', 'zingVariant', 'ultrasonicVariant', or 'firmwareVariant'
 * Returns 'normal' | 'rgb' | null (if not explicitly set)
 */
const getZingUltrasonicVariant = () => {
    try {
        const raw =
            sessionStorage.getItem('hardwareVariant') ||
            sessionStorage.getItem('zingVariant') ||
            sessionStorage.getItem('ultrasonicVariant') ||
            sessionStorage.getItem('firmwareVariant') ||
            ''
        const normalized = String(raw).trim().toLowerCase()
        if (
            [
                'normal',
                'normal_ultrasonic',
                'normal ultrasonic',
                'normalultrasonic',
                'normal-ultrasonic',
                'without_rgb',
                'withoutrgb',
            ].includes(normalized)
        ) {
            return 'normal'
        }
        if (
            [
                'rgb',
                'rgb_ultrasonic',
                'rgb ultrasonic',
                'rgbultrasonic',
                'rgb-ultrasonic',
                'with_rgb',
                'withrgb',
            ].includes(normalized)
        ) {
            return 'rgb'
        }
    } catch (e) {
        console.error('Failed to read Zing ultrasonic variant from sessionStorage:', e)
    }
    return null
}

const isZingWithoutRGB = (connectedDevice, deviceVersion) => {
    if (connectedDevice !== 'Humanoid') return false
    const variant = getZingUltrasonicVariant()
    if (variant === 'normal') return true
    if (variant === 'rgb') return false

    const [major, minor] = String(deviceVersion || '0.0.0')
        .split('.')
        .map(Number)
    return major > 2 || (major === 2 && minor >= 1)
}

export {
    compareVersion,
    getVersionArguments,
    getVersionSeries,
    getVersionObjNameKey,
    isVersionAbove,
    isVersionAtLeast,
    PEECEE_MIN_FIRMWARE_BY_BRANCH,
    getPeeCeeMinFirmwareForVersion,
    getZingMinFirmwareForVersion,
    getRequiredFirmwareMin,
    getZingUltrasonicVariant,
    isZingWithoutRGB,
}

